import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import {
  ContextItem,
  RequirementContextType,
  RequirementStatusViewProps
} from "../../../../types";
import { WSPillProps } from "@wingspanhq/fe-component-library";
import { IIdentityVerificationRequestResponse } from "@wingspanhq/users";
import { IdentityVerificationRequestStatus } from "@wingspanhq/users/dist/lib/interfaces/identityVerificationRequest";

export const getIdentityVerificationRequirementStatus = (
  requirement: IRequirementResponse,
  contextItem: ContextItem,
  identityVerificationRequest: IIdentityVerificationRequestResponse | undefined,
  contextType: RequirementContextType
): RequirementStatusViewProps => {
  let pill: WSPillProps;
  let secondaryText: string | undefined;

  if (
    identityVerificationRequest?.status ===
    IdentityVerificationRequestStatus.Complete
  ) {
    pill = {
      theme: "success",
      text: "Complete",
      icon: true
    };
  } else if (
    identityVerificationRequest?.status ===
    IdentityVerificationRequestStatus.Failed
  ) {
    pill = {
      theme: "error",
      text: "Failed",
      icon: true
    };
  } else {
    if (contextType === RequirementContextType.Payee) {
      pill = {
        theme: "neutral",
        text: "Awaiting contractor",
        icon: "time"
      };
      secondaryText = "Awaiting contractor completion";
    } else {
      pill = {
        theme: "warning",
        text: "Action required",
        icon: true
      };
      secondaryText = "Awaiting your completion";
    }
  }

  return {
    pill,
    secondaryText
  };
};
